import { atom  } from "recoil";

export const bookingOptions = atom({
    key: "optimizationState",
    default: {
        optimizedBooking: false
    },
})

export const oldBookingState = atom({
    key: "oldBooking",
    default: {
    },
})

export const newBookingState = atom({
    key: "newBooking",
    default: {
    },
})